namespace Portico.Models.Legacy {
    
    export class PatientSearchRecordModel {
        firstName: string;
        lastName: string;
        dateOfBirth: Date;
        address1: string;
        city: string;
        state: string;
        postalCode: string;
        country: string;
        memberNumber: string;
        cardStartDate: Date;
        cardEndDate: Date;
        cardActivationDate: Date;
        eligibilityStatusCode: EligibilityStatusCodeEnum;
        eligibilityStatusDescription: string;
        eligibilityDate: string;
        bin: string;
        sponsorNumber: string;
        personId: number;
        alternateCardIds: Array<AlternateCardId>;
        email: string;
        phone: string;
        groupNumber: string;
        totalBenefitAmount: number;
        remainingBenefitAmount: number;
        totalPaidAmount: number;
        communicationTypes: CommunicationTypesEnum;

        constructor(obj?: Portico.Services.Legacy.EnrollmentService.Models.PatientSearchRecordModel){
            this.firstName = null;
            this.lastName = null;
            this.dateOfBirth = null;
            this.address1 = null;
            this.city = null;
            this.state = null;
            this.postalCode = null;
            this.country = null;
            this.memberNumber = null;
            this.cardStartDate = null;
            this.cardEndDate = null;
            this.cardActivationDate = null;
            this.eligibilityStatusCode = null;
            this.eligibilityStatusDescription = null;
            this.eligibilityDate = null;
            this.bin = null;
            this.sponsorNumber = null;
            this.personId = null;
            this.alternateCardIds = null;
            this.email = null;
            this.phone = null;
            this.groupNumber = null;
            this.totalBenefitAmount = null;
            this.remainingBenefitAmount = null;
            this.totalPaidAmount = null;
            this.communicationTypes = null;

            if(obj){
                this.firstName = obj.firstName || null;
                this.lastName = obj.lastName || null;
                this.dateOfBirth = typeof obj.dateOfBirth === 'string' ? new Date(obj.dateOfBirth) : obj.dateOfBirth || null;
                this.address1 = obj.address1 || null;
                this.city = obj.city || null;
                this.state = obj.state || null;
                this.postalCode = obj.postalCode || null;
                this.country = obj.country || null;
                this.memberNumber = obj.memberNumber || null;
                this.cardStartDate = typeof obj.cardStartDate === 'string' ? new Date(obj.cardStartDate) : obj.cardStartDate || null;
                this.cardEndDate = typeof obj.cardEndDate === 'string' ? new Date(obj.cardEndDate) : obj.cardEndDate || null;
                this.cardActivationDate = typeof obj.cardActivationDate === 'string' ? new Date(obj.cardActivationDate) : obj.cardActivationDate || null;
                this.eligibilityStatusCode = obj.eligibilityStatusCode || null;
                this.eligibilityStatusDescription = obj.eligibilityStatusDescription || null;
                this.eligibilityDate = obj.eligibilityDate || null;
                this.bin = obj.bin || null;
                this.sponsorNumber = obj.sponsorNumber || null;
                this.personId = obj.personId || null;
                this.alternateCardIds = (obj.alternateCardIds || []).map(item => new AlternateCardId(item || null));
                this.email = obj.email || null;
                this.phone = obj.phone || null;
                this.groupNumber = obj.groupNumber || null;
                this.totalBenefitAmount = obj.totalBenefitAmount || null;
                this.remainingBenefitAmount = obj.remainingBenefitAmount || null;
                this.totalPaidAmount = obj.totalPaidAmount || null;
                this.communicationTypes = obj.communicationTypes || null;
            }
        }

        public toModel(): Portico.Services.Legacy.EnrollmentService.Models.PatientSearchRecordModel {
            return {
                firstName: this.firstName,
                lastName: this.lastName,
                dateOfBirth: this.dateOfBirth,
                address1: this.address1,
                city: this.city,
                state: this.state,
                postalCode: this.postalCode,
                country: this.country,
                memberNumber: this.memberNumber,
                cardStartDate: this.cardStartDate,
                cardEndDate: this.cardEndDate,
                cardActivationDate: this.cardActivationDate,
                eligibilityStatusCode: this.eligibilityStatusCode,
                eligibilityStatusDescription: this.eligibilityStatusDescription,
                eligibilityDate: this.eligibilityDate,
                bin: this.bin,
                sponsorNumber: this.sponsorNumber,
                personId: this.personId,
                alternateCardIds: this.alternateCardIds.map(item => item.toModel()),
                email: this.email,
                phone: this.phone,
                groupNumber: this.groupNumber,
                totalBenefitAmount: this.totalBenefitAmount,
                remainingBenefitAmount: this.remainingBenefitAmount,
                totalPaidAmount: this.totalPaidAmount,
                communicationTypes: this.communicationTypes,
            };
        }
    }   
}